import React from 'react'
import css from './meetingRoomCard.module.scss'

export default ({ reserve }: { reserve: any }) => (
  <div className={css.clocks_container}>
    <h6>Reserve for</h6>
    <div className={css.clocks}>
      {[15, 30, 45, 60].map((t) => (
        <Clock key={`c-${t}`} time={t} onClick={() => reserve(t)} />
      ))}
    </div>
  </div>
)

const Clock = ({ time, onClick }: { time: number; onClick: () => void }) => (
  <div className={css.clock} onClick={onClick}>
    <span>{time}</span>
  </div>
)
